import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.findingsOverview || initialState;

export const selectFindingsOverview = createSelector(
  [selectDomain],
  dashboardState => dashboardState,
);
